import { CxmEntityType } from '../types/cxm-entity-type';
export const toV2EntityType = (entityType) => {
    switch (entityType) {
        case CxmEntityType.FilmList:
            return 'FilmList';
        case CxmEntityType.FilmHeroBanner:
            return 'FilmHeroBanner';
        case CxmEntityType.FilmShowtimePicker:
            return 'FilmShowtimePicker';
        default:
            throw new Error(`Received unexpected value for EntityType: '${entityType}`);
    }
};
